module.exports = __webpack_public_path__ + "img/member-welfare-bg.3023c117.png";